import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { FormTabs } from '@dreryk/react-components';

import {
   medicalImagingTranslationKeys,
   medicalInformationTranslationKeys,
   subjectiveAssessmentTranslationKeys,
} from '../../../translations';
import { VisitFormController } from '../visitForm.types';

import { MedicalImagingTable } from './medicalImaging/MedicalImagingTable';
import { MedicalInformationTable } from './medicalInformation/MedicalInformationTable';
import { SubjectiveAssessmentTextEditor } from './SubjectiveAssessmentTextEditor';

type ExaminationTabsProps = {
   readonly controller: VisitFormController;
   readonly visitId: number;
   readonly patientId: number;
   readonly practitionerId: PractitionerId;
};

export const ExaminationTabs = (props: ExaminationTabsProps): JSX.Element => {
   return (
      <FormTabs
         testId={'examinationFormTabs'}
         formState={props.controller.formState}
         initialActiveTabId={'subjectiveAssessment'}
      >
         <FormTabs.Tab
            label={subjectiveAssessmentTranslationKeys.tab}
            id={'subjectiveAssessment'}
            register={props.controller.register}
         >
            <SubjectiveAssessmentTextEditor
               controller={props.controller.register('subjectiveAssessments')}
               practitionerId={props.practitionerId}
               visitId={props.visitId}
            />
         </FormTabs.Tab>
         <FormTabs.Tab
            label={medicalImagingTranslationKeys.tab}
            id={'medicalImaging'}
            register={props.controller.register}
         >
            <MedicalImagingTable visitId={props.visitId} patientId={props.patientId} controller={props.controller} />
         </FormTabs.Tab>
         <FormTabs.Tab
            label={medicalInformationTranslationKeys.tab}
            id={'otherMedicalInformation'}
            register={props.controller.register}
         >
            <MedicalInformationTable visitId={props.visitId} patientId={props.patientId} />
         </FormTabs.Tab>
      </FormTabs>
   );
};
